import { useUserStore } from "../stores/modules/user";
import useClipboard from "vue-clipboard3";
let $Toast = null;
let $ErrorToast = null;
const Utils = {
  // 路由返回
  $back() {
    window.history.back();
  },
  // 克隆
  $clone(v) {
    return JSON.parse(JSON.stringify(v));
  },
  // 存储
  $storageSet(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  // $storageGet(key, defaultValue = "") {
  //   let res = localStorage.getItem(key);
  //   if (res) {
  //     return JSON.parse(res);
  //   }
  //   return defaultValue;
  // },
  // 获取存储
  $storageGet(key, defaultValue = "") {
    const res = localStorage.getItem(key);
    if (!res) return defaultValue;
    try {
      return JSON.parse(res);
    } catch (e) {
      return res;
    }
  },
  // 清除存储
  $storageClear(key, isAll = false) {
    if (isAll) {
      localStorage.clear();
    } else {
      localStorage.removeItem(key);
    }
  },
  $getLogin() {
    const userStore = useUserStore();
    return userStore.isLogin;
  },
  $formatMoney(value, format = true) {
    const amount = format ? value / 100000000 || 0 : value || 0;
    const inputNumber = parseFloat(amount);
    const formattedNumber = inputNumber.toFixed(2);
    const [integerPart, decimalPart] = formattedNumber.split(".");
    const formattedIntegerPart = integerPart.replace(
      /\B(?=(\d{3})+(?!\d))/g,
      ","
    );
    const result = {
      value,
      amount,
      formatted: `${formattedIntegerPart}.${decimalPart}`,
      integerPart: formattedIntegerPart,
      decimalPart: `.${decimalPart}`
    };
    return result;
  },
  $floatMoney(number) {
    return number / (10000 * 10000);
  },
  // 时间格式化
  $formatTimestamp(timestamp, format = "YYYY-MM-DD HH:mm") {
    // 如果是10位的时间戳，转换为毫秒
    if (String(timestamp).length === 10) {
      timestamp = timestamp * 1000;
    }
    const date = new Date(timestamp);

    const padZero = num => (num < 10 ? "0" + num : num);

    const year = date.getFullYear();
    const month = padZero(date.getMonth() + 1); // 月份从0开始，因此要加1
    const day = padZero(date.getDate());

    const hours = padZero(date.getHours());
    const minutes = padZero(date.getMinutes());
    const seconds = padZero(date.getSeconds());

    // 替换格式字符串中的标记
    return format
      .replace("YYYY", year)
      .replace("MM", month)
      .replace("DD", day)
      .replace("HH", hours)
      .replace("mm", minutes)
      .replace("ss", seconds); // 可选: 你可以添加秒的格式化
  },
  // 用户判断是否为7天内
  $isWithinLastSevenDays(date) {
    const currentDate = new Date();
    const targetDate = new Date(date);
    const diffTime = Math.abs(currentDate - targetDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays <= 7;
  },
  // 复制到剪贴板
  async $copy(text) {
    const { toClipboard } = useClipboard();
    try {
      // await navigator.clipboard.writeText(text);
      toClipboard(text + "");
      if ($Toast) {
        $Toast("Cópia Bem-sucedida");
      }
      console.log("Text copied to clipboard");
    } catch (error) {
      if ($Toast) {
        $Toast(error);
      }
      console.error("Failed to copy text: ", error);
    }
  },
  $isObject(value) {
    return (
      typeof value === "object" &&
      value !== null &&
      Object.prototype.toString.call(value) === "[object Object]"
    );
  },
  $checkPhone(value) {
    const regex = /^\d{9,11}$/;
    return regex.test(value);
  },
  $checkEmail(value) {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(value);
  },
  $checkAccount(value) {
    const regex = /^[A-Za-z0-9!#$%^&*()_+={}\[\]|\\:;,.<>?/~`-]{6,16}$/;
    return regex.test(value);
  },
  $checkAccountType(value) {
    if (/^\d+$/.test(value)) {
      return "phone";
    } else if (/@/.test(value)) {
      return "email";
    } else if (/[a-zA-Z]/.test(value)) {
      return "account";
    } else {
      return "unknown";
    }
  },
  
};
// 提示
export function setToast(toastFunction) {
  $Toast = toastFunction;
}
// 错误提示
export function setErrorToast(toastFunction) {
  $ErrorToast = toastFunction;
}
export { $Toast, $ErrorToast };
export default Utils;
